const defaultNamePrefix = 'Новый отчёт';
export default defaultNamePrefix;
